module.exports = __webpack_public_path__ + "img/body-care-5.5dbb98f.webp";